// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { getCurrentSpan } from '@imprivata-cloud/common';
import type { TraceContext } from '@imprivata-cloud/common/types';
import type { Span } from '@opentelemetry/api';
import { getWorkflowId } from './index';

export function getB3Descriptor(span: Span): string {
  // https://github.com/openzipkin/b3-propagation#sampling-state-2
  const sampled = '1';
  // @ts-expect-error - Unknown
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { traceId, spanId } = span._spanContext;

  return `${traceId as string}-${spanId as string}-${sampled as string}`;
}

export function getTraceContext(): TraceContext {
  const workflowId = getWorkflowId();
  const currentSpan = getCurrentSpan();
  return {
    workflowId,
    spanContext: currentSpan ? getB3Descriptor(currentSpan) : '',
  };
}
